import { render, staticRenderFns } from "./BarChartStack.vue?vue&type=template&id=0b581ff4"
import script from "./BarChartStack.vue?vue&type=script&lang=js"
export * from "./BarChartStack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports